// Antd
import { Button } from 'antd'
import { ColumnsType } from 'antd/es/table'

// Components
import { BaseTableAction, BaseTableBody } from 'components'

// Interfaces
import { IUserUpdateBulkInsertForm } from 'interfaces/back-office/user'
import { ITableProps } from './interfaces'

// i18n
import { useTranslation } from 'react-i18next'
import { PlusOutlined } from '@ant-design/icons'

// Mobx React
import { observer } from 'mobx-react'

const Table = observer(({ loading, forms, add, remove, edit }: ITableProps) => {
  // Hook
  const { t } = useTranslation()

  // Common State
  const columns: ColumnsType<IUserUpdateBulkInsertForm> = [
    {
      key: 'name',
      title: t('user.table.name'),
      dataIndex: 'name',
    },
    {
      key: 'email',
      title: t('user.table.email'),
      dataIndex: 'email',
    },
    {
      key: 'companyName',
      title: t('user.table.company'),
      dataIndex: 'companyName',
    },
    {
      key: 'fieldName',
      title: t('app.user.companyData.form.field'),
      dataIndex: 'fieldName',
    },
    {
      key: 'x',
      title: t('app.table.action'),
      dataIndex: '',
      render: (_, record) => {
        return <BaseTableAction isShow={false} onClickDelete={() => remove(record.id)} onClickEdit={() => edit(record.id)} />
      },
    },
  ]

  return (
    <BaseTableBody
      loading={loading}
      columns={columns}
      dataSource={forms}
      footer={() => (
        <div className="flex items-center justify-center">
          <Button type="primary" className="custom-button" onClick={() => add()}>
            <div className="flex items-center">
              <PlusOutlined className="mr-2" />
              {t('user.title.addUser')}
            </div>
          </Button>
        </div>
      )}
    />
  )
})

export { Table }
